
export enum TipoConfiguracaoEmpresaEnum {
  DadosColetados = 'DadosColetados',
}
